import clsx from 'clsx';
import { Heading } from 'components/src/typography';
import Image from 'next/image';
import * as React from 'react';
import { LargeCardFieldsFragment } from 'types/generated';
import DefaultRichText from '../DefaultRichText';
import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown';
import { getOr } from '@/utils/options';
import { Document } from '@contentful/rich-text-types';
import CardButton from '../Card/CardButton';

type Props = {
  cardData: LargeCardFieldsFragment | null;
  classes: string;
};

const RoamingCard = ({ cardData, classes }: Props) => {
  const [markdownDescription, setMarkdownDescription] = React.useState<Document | undefined>(undefined);

  React.useEffect(() => {
    const fetchMarkdownDocument = async () => {
      const document = await richTextFromMarkdown(getOr(cardData?.description, ''));
      setMarkdownDescription(document);
    };
    fetchMarkdownDocument();
  }, [cardData?.description]);

  return (
    <div className={clsx('flex flex-col gap-32 rounded-28 border-1 border-black-25 p-32', classes)}>
      <div className="flex flex-col gap-16">
        <div className="flex justify-between">
          <Heading variant="xs">{cardData?.title}</Heading>
          {cardData?.icon?.url && <Image width={40} height={40} src={cardData?.icon?.url} alt="" />}
        </div>
        {markdownDescription && <DefaultRichText data={markdownDescription} />}
      </div>
      {cardData?.button?.label && <CardButton buttonData={cardData.button} autoWidth />}
    </div>
  );
};
export default RoamingCard;
